module.exports = __webpack_public_path__ + "static/randyunger-fb4185622a46eb1fabc69c7d497b2a24.png";